import { faWarning } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { FontAwesomeIcon } from 'atoms/icons';
import { BodyL, HeadlineS } from 'atoms/typography';

const Root = styled.div`
  padding: var(--intermediate-unit);
  width: 100%;
  background: linear-gradient(
      0deg,
      var(--c-surface-caution),
      var(--c-surface-caution)
    ),
    var(--c-black);
  border: 1px solid var(--c-yellow-400);
  border-radius: var(--unit);
`;

type Props = {
  title: ReactNode;
  message: ReactNode;
};
export const Alert = ({ title, message }: Props) => {
  return (
    <Root>
      <HeadlineS>
        <FontAwesomeIcon icon={faWarning} color="var(--c-yellow-400)" /> {title}
      </HeadlineS>
      {typeof message === 'string' ? <BodyL>{message}</BodyL> : message}
    </Root>
  );
};
